$(window).load(function(){
  $('.preloader').addClass('none');
});
function increaseValue() {
  var value = parseInt(document.getElementById('Quantity-product-template').value, 10);
  value = isNaN(value) ? 1 : value;
  value++;
  document.getElementById('Quantity-product-template').value = value;
}

function decreaseValue() {
  var value = parseInt(document.getElementById('Quantity-product-template').value, 10);
  value = isNaN(value) ? 1 : value;
  value < 2 ? value = 2 : '';
  value--;
  document.getElementById('Quantity-product-template').value = value;
}
$( document ).ready(function() {
  $( ".tag--title" ).click(function() {
    var parrent = $(this).parent();
    parrent.toggleClass('open');
  });
});
$(document).on("click", function (e) {
  if ($(e.target).is(".tag--title") === false) {
    $(".tags-wrapper").removeClass("open");
  }
});

$(document).ready(function(){
  $('#easyReadMore').on('click', function(){
    if(!$(this).hasClass('readLess')){
    	$('#easyMore').css('display', 'inline-block');
      	$(this).addClass('readLess').text('HIDE IMPORTANT INFORMATION')
    }else{
    	$('#easyMore').css('display', 'none');
      	$(this).removeClass('readLess').text('CLICK HERE FOR IMPORTANT INFORMATION')
    }
  })
})